export type StaticInfoState = {
    originalList: BinInfo[] | [];
    changingList: BinInfo[] | [];
    binGroupList: BinInfo[] | [];
    enquiryType: EnquiryType[] | [];
    districtList: DistrictList[] | [];
    cleanerList: CleanerList[] | [];
    contractList: ContractList[] | [];
    binTypeList: BinTypeList[] | [];
    containerList:ContainerList[]|[]
    recylcableList:RecylcableList[]|[]
    depotList:DepotList[]|[]
    zoneList:ZoneList[]|[]
    filteredZoneList:ZoneList[]|[]
};

export interface BinTypeList {
    bin_type: string | null;
    create_by: number | null;
    update_by: number | null;
    bin_type_id: number | null;
    create_by_username: string;
    update_by_username: string;
    create_date: moment.Moment | Date | null;
    update_date: moment.Moment | Date | null;
}

export type BinInfo = {
    // must use label and value because of react-select library
    label: string; // it is bin_full_name
    value: number; // it is bin_id
    contract_id?:number,
    district_id?: number;
    area_id?: number;
    time_start?: string;
    time_end?: string;
    __uniqueId?: string;
};

export interface EnquiryType {
    enquiry_type_id: number;
    enquiry_type: string;
}

export interface CleanerList {
    username: string;
    user_id: number;
}

export interface DistrictList {
    district_id: number;
    district_cn: string;
    district_en: string;
    area_id: number;
    area_cn: string;
    area_en: string;
}

export interface ContractList {
    contract_id: number;
    contract: string;
    is_active: string;
    need_inspect?: string;
    image_type_id: string;
    report_title?: string;
}

export interface ContainerList {
    container_id:number,
    container:string,
    weight:number
}

export interface RecylcableList{
    recyclable_id: number,
    recyclable: string
}

export interface DepotList {
    contract_id: number,
    depot_cn: string,
    depot_id: number
}

export interface ZoneList{
    zone_id:number,
    zone_name:string,
    contract_id:number
}

export const staticInfoState: StaticInfoState = {
    originalList: [],
    changingList: [],
    binGroupList: [],
    enquiryType: [],
    districtList: [],
    cleanerList: [],
    contractList: [],
    binTypeList: [],
    containerList:[],
    recylcableList:[],
    depotList:[],
    zoneList:[],
    filteredZoneList:[]
};
